import { render, staticRenderFns } from "./OringRight.vue?vue&type=template&id=7f2faba4&scoped=true&"
import script from "./OringRight.vue?vue&type=script&lang=js&"
export * from "./OringRight.vue?vue&type=script&lang=js&"
import style0 from "./OringRight.vue?vue&type=style&index=0&id=7f2faba4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2faba4",
  null
  
)

export default component.exports